// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_6f4830d6","iconWrap":"_23a87a7d","icon":"_bbb10249"};